/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';

/**
 *
 * @export
 * @interface WebApiIntegrationsDtoExternalArticleDto
 */
export interface WebApiIntegrationsDtoExternalArticleDto {
    /**
     *
     * @type {string}
     * @memberof WebApiIntegrationsDtoExternalArticleDto
     */
    articleNumber?: string | null;
    /**
     *
     * @type {string}
     * @memberof WebApiIntegrationsDtoExternalArticleDto
     */
    name?: string | null;
    /**
     *
     * @type {string}
     * @memberof WebApiIntegrationsDtoExternalArticleDto
     */
    description?: string | null;
    /**
     *
     * @type {number}
     * @memberof WebApiIntegrationsDtoExternalArticleDto
     */
    salesPrice?: number | null;
    /**
     *
     * @type {number}
     * @memberof WebApiIntegrationsDtoExternalArticleDto
     */
    vat?: number | null;
    /**
     *
     * @type {string}
     * @memberof WebApiIntegrationsDtoExternalArticleDto
     */
    unit?: string | null;
}

/**
 * Check if a given object implements the WebApiIntegrationsDtoExternalArticleDto interface.
 */
export function instanceOfWebApiIntegrationsDtoExternalArticleDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiIntegrationsDtoExternalArticleDtoFromJSON(json: any): WebApiIntegrationsDtoExternalArticleDto {
    return WebApiIntegrationsDtoExternalArticleDtoFromJSONTyped(json, false);
}

export function WebApiIntegrationsDtoExternalArticleDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiIntegrationsDtoExternalArticleDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'articleNumber': !exists(json, 'articleNumber') ? undefined : json['articleNumber'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'salesPrice': !exists(json, 'salesPrice') ? undefined : json['salesPrice'],
        'vat': !exists(json, 'vat') ? undefined : json['vat'],
        'unit': !exists(json, 'unit') ? undefined : json['unit'],
    };
}

export function WebApiIntegrationsDtoExternalArticleDtoToJSON(value?: WebApiIntegrationsDtoExternalArticleDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'articleNumber': value.articleNumber,
        'name': value.name,
        'description': value.description,
        'salesPrice': value.salesPrice,
        'vat': value.vat,
        'unit': value.unit,
    };
}
